import React from 'react';
import { Dialog, DialogContent, IconButton, DialogActions, Button, Typography, Box, Stack } from '@mui/material';
import { CloseIcon } from 'icons';
import { useStyles } from './styles';

interface CancelDialogProps {
  open: boolean;
  handleClose(): void;
  handleSubmit(): void;
  title: string;
  subtitle: string;
  cancelBtn: string;
  submitBtn: string;
}

const CancelDialog = (props: CancelDialogProps) => {
  const { open, handleClose, handleSubmit, title, subtitle, cancelBtn, submitBtn } = props;

  const { classes } = useStyles();

  return (
    <Dialog open={open} onClose={handleClose}>
      <IconButton onClick={handleClose} className={classes.closeBtn} size="large">
        <CloseIcon />
      </IconButton>
      <DialogContent className={classes.dialogContent}>
        <Box mb={3} display="flex" justifyContent="center">
          <Typography variant="h2">{title}</Typography>
        </Box>
        <Box display="flex" justifyContent="center">
          <Typography variant="subtitle1" color="gray" sx={{ maxWidth: 300, textAlign: 'center' }}>
            {subtitle}
          </Typography>
        </Box>
        <DialogActions className={classes.actions} sx={{ marginTop: 3 }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Button fullWidth onClick={handleClose} variant="outlined">
              {cancelBtn}
            </Button>
            <Button fullWidth onClick={handleSubmit} variant="contained">
              {submitBtn}
            </Button>
          </Stack>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default CancelDialog;
